import { Fragment } from 'react';
import { Typography } from '../Typography';
import {
  DescriptionsTable,
  DescriptionsTd,
  DescriptionsTh,
  DescriptionsTr,
} from './Descriptions.styled';
import type { DescriptionsProps } from './Descriptions.types';

export const Descriptions = ({
  size = 'S',
  styledComponents,
  items,
  ...props
}: DescriptionsProps) => {
  return (
    <DescriptionsTable as='table' {...props} {...styledComponents?.table}>
      <tbody>
        {items.map((item, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: unique 값 없음
          <DescriptionsTr {...styledComponents?.tr} key={index}>
            {item.map((list) => (
              <Fragment key={list.key}>
                <DescriptionsTh size={size} {...styledComponents?.th}>
                  <Typography fontType='body2.medium'>{list.label}</Typography>
                </DescriptionsTh>
                <DescriptionsTd size={size} {...styledComponents?.td} colSpan={list.span ?? 1}>
                  {list.content}
                </DescriptionsTd>
              </Fragment>
            ))}
          </DescriptionsTr>
        ))}
      </tbody>
    </DescriptionsTable>
  );
};
